import { render, staticRenderFns } from "./GreenCoffeeBeanExtract.vue?vue&type=template&id=e22aab46&scoped=true&"
import script from "./GreenCoffeeBeanExtract.vue?vue&type=script&lang=js&"
export * from "./GreenCoffeeBeanExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22aab46",
  null
  
)

export default component.exports